/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { GET_DRAFT_APPLICATIONS } from '../../api/graphql';
import moment from 'moment-timezone';
import { toHeaderCase } from 'js-convert-case';
import { vappContainer } from '@/application';
import { Graphql } from '@common/graphql';
import { AppNavigatorService } from '@/AppNavigator';
import { apiConfig } from '@/config/apiConfig';
import { userListConfig } from '../../config/userLists.config';
import { APPLICATION_TYPE } from '@/config/applicationType.config';
import { APPLICATION_STATUS } from '@/config/applicationStatus.config';

export interface IPaymentTransactionMethods extends IPluginMethodMap {
  getPaymentTransaction(args: any): Promise<any>;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export class PaymentTransactionService implements IAgentPlugin {
  readonly methods: IPaymentTransactionMethods;

  constructor() {
    this.methods = {
      getPaymentTransaction: this.getPaymentTransactionProps.bind(this),
    };
  }

  async getPaymentTransactionProps(args: any) {
    console.log(`getPaymentTransactionProps args`, args);
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    // const token = getToken();
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();

    console.log('data in query', args);
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;

    const userProfile = storageService.get('myProfile', 'session');
    const role = userProfile?.org?.orgRole;
    console.log('roetrn-->', role);
    // const vuid = userProfile?.vuid;
    // const formDataConfig = getSrv()?.agent.getFormData();

    const whoAmI =
      userData?.currentRole ??
      (userData?.userRoles && Array.isArray(userData?.userRoles)
        ? userData?.userRoles[0]?.name
        : null);

    try {
      if (client) {
        // const statusValue =
        //   whoAmI === 'prospective_employee'
        //     ? ['APPLICANT_DRAFT']
        //     : ['APPLICATION_INCOMPLETE', 'APPLICANT_DRAFT'];
        // const roetable = [
        //   {
        //     column: 'type',
        //     op: 'In',
        //     value: ['CARICOM_RENEW_WORK_PERMIT','CARICOM_NEW_WORK_PERMIT'],
        //   },
        // ];
        const res = await client.query(GET_DRAFT_APPLICATIONS, {
          input: {
            where: [
              ...args?.where
              // trn?null:roetable
            ],
            order: [
              {
                column: 'paidOn',
                direction: 'DESC',
              },
            ],
            limit: args?.size,
            skip: args?.offset,
          },
        });
        if (res?.data) {
          console.log(`table data2`, res);
          let _rowData = this.formatUserTable(
            res?.data?.getListOfPayment?.data
          );
          console.log(`row data`, _rowData);
          return {
            ...userListConfig,
            ultUsers: _rowData,
            //userRoles: res?.data?.getRoleList?.data,
            isEmpty: _rowData
              ? res?.data?.getListOfPayment?.data?.length <= 0
              : true,
            // studentGroup: holderGroups,
            activePage: res?.data?.getListOfPayment?.currentPage,
            pageSize: res?.data?.getListOfPayment?.pageSize,
            totalCount: res?.data?.getListOfPayment?.totalCount,
            totalPages: res?.data?.getListOfPayment?.totalPages,
          };
        } else {
          console.log('hiii', res);
          if (res?.error) {
            return {
              error: true,
              isEmpty: true,
            };
          }
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        error: true,
        isEmpty: true,
      };
    }
  }

  private formatUserTable(data: any) {
    console.log("formatusertab;le",data);
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any, index: number) => {
        return {
          id: item?.application?.applicationNo ?? '-',
          name: item?.application?.applicantInfo?.lastName || item?.application?.applicantInfo?.firstName ?`${ item?.application?.applicantInfo?.lastName
            ? toHeaderCase(item?.application?.applicantInfo?.lastName):''}, ${
                item?.application?.applicantInfo?.firstName
                  ? toHeaderCase(item?.application?.applicantInfo?.firstName)
                  : ''
              }`:'-',
            // : '',
            status: this.getFormattedStatus(item?.status) ?? '-',
            applicationId: item?.application?.applicationNo ?? ' - ',
            applicationType: this.getFormattedType(item?.application?.type) ?? '-',
            savedOn: this.formatCreatedDate(item?.paidOn) ?? '-',
            amount : item?.formattedAmt ?? '-',
            paymentId:item?.paymentId ?? '-',
            orgName:item?.application?.employerInfo?.name ?? '-',
        };
      });
      console.log("asdfasdfsdfasdfsdfsfaf",_rowData);
    return _rowData;
  }

  private formatCreatedDate(date: Date) {
    if (date) {
      return moment(date).format('LLL');
    }
  }

  private getFormattedType(type: string) {
    if (APPLICATION_TYPE?.[type]) {
      return APPLICATION_TYPE?.[type];
    }
    return '-';
  }
  private getFormattedStatus(status: string) {
    if (APPLICATION_STATUS?.[status]) {
      return APPLICATION_STATUS?.[status];
    }
    return '-';
  }
}
